import {
  Box,
  Button,
  CardMedia,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import colors from "app/style/Colors";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { CreateProductServices } from "app/apis/CreateProduct/CreateProductServices";
import { ErrorToaster, SuccessToaster } from "app/components/UI/Toaster";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../../../axios";

function Step3ViewProduct(props) {
  const [filterDataColorAndSize, setfilterDataColorAndSize] = useState([]);
  const [SelectColor, setSelectColor] = useState();
  const [FilterSize, setFilterSize] = useState([]);
  console.log("🚀 FilterSize:", FilterSize);

  const [allSizes, setAllSizes] = useState([]);
  const [Loading, setLoading] = useState(false);

  const baseURL = baseUrl;
  // props data ------->
  const {
    data,
    handleStep,
    allSize,
    allColor,
    customisePictureData,
    MainCategory,
  } = props;
  console.log("🚀 data,:", data);

  const navigate = useNavigate();
  // Data to be filter for Display

  const filterData = () => {
    let variations = [];
    data.productdetails.forEach((element) => {
      const index = variations.findIndex(
        (e) => e.color_id === element.color.id
      );
      if (index === -1) {
        let fit = element.size.map((item) => ({
          fittype_id: item.id,
          fittype_name: item.name,
        }));
        // {
        // fittype_id: element.size.id,
        // fittype_name: element.size.name,
        // fittype_id: element.size.map((item) => item.id),
        // fittype_name: element.size.map((item) => item.name),
        // },
        let obj = {
          fittype: fit,
          color_id: element.color.id,
          color_name: element.color.name,
          color_code: element.color.code,
        };
        variations.push(obj);
      } else {
        const updateFit = [...variations[index].fittype];
        const fitTypeIndex = updateFit.findIndex(
          (e) => e.fittype_id === element.size.id
        );
        if (fitTypeIndex === -1) {
          let obj = {
            // fittype_id: element.size.id,
            // fittype_name: element.size.name,
            fittype_id: element.size.map((item) => item.id),
            fittype_name: element.size.map((item) => item.name),
          };
          updateFit.push(obj);
        }
        variations[index].fittype = updateFit;
      }
      setfilterDataColorAndSize(variations);
    });
  };

  // Submit Data
  const SubmitData = async () => {
    setLoading(true);
    try {
      // setData ================>
      let FinalData;
      const productdetails = data?.productdetails.map((data) => {
        return {
          productdetailsfittypes: data.size.map((item) => ({
            fittype_id: item.id,
            fittype_name: item.name,
          })),
          color_id: data.color.id,
          qty: data.qty,
          productdetailsimages: data.image,
        };
      });
      // Final Data =============>
      if (data.type === "NotCustomizable") {
        FinalData = {
          name: data.name,
          category_id: data.category.id,
          sku: data.sku,
          description: data.description,
          type: data.type,
          price: data.price,
          productdetails: productdetails,
          bannerimage: data.bannerimage,
        };
      } else {
        FinalData = {
          name: data.name,
          category_id: data.category.id,
          sku: data.sku,
          description: data.description,
          type: data.type,
          price: data.price,
          productdetails: productdetails,
          productcustomiseimages: customisePictureData,
          bannerimage: data.bannerimage,
        };
      }
      const result = await CreateProductServices.createProduct(FinalData);
      if (result.responseCode === 200) {
        SuccessToaster("product Created Successfully");
      } else {
        ErrorToaster("Oops Error Occur");
      }
    } catch (e) {
      ErrorToaster(e);
    } finally {
      setLoading(false);
      navigate("/Productmanagement/viewallproduct");
      // ErrorToaster("error occur");
    }
  };

  // Handle Steps for Previous Button
  const handlePreviousButton = () => {
    if (data.type === "Customizable") {
      handleStep("prev", 1);
    } else {
      handleStep("prev", 2);
    }
  };

  const setColor = (Colors) => {
    console.log(Colors);
    setSelectColor(Colors.color_name);
    setFilterSize(Colors.fittype);
  };

  // Use Effect---------->
  useEffect(() => {
    filterData();
  }, data);

  return (
    <>
      {/* Product Info============================> */}

      <Typography variant="h4" sx={{ fontWeight: "900" }}>
        Product Info
      </Typography>
      <Grid container display="flex" gap="20px">
        {/* Render Images ===================> */}
        <Grid item md="6">
          <Grid
            container
            gap="20px"
            display="flex"
            justifyContent={"center"}
            sx={{
              boxShadow:
                "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;",
              padding: "20px",
            }}
          >
            {data.productdetails.map((imageFile, i) => {
              return (
                <Grid key={i} item sm="3" xs="5" sx={{ cursor: "pointer" }}>
                  <CardMedia
                    component="img"
                    height="100%"
                    image={baseURL + imageFile.image[0].image}
                    width="100%"
                    sx={{
                      objectFit: "cover",
                      alignSelf: "center",
                      justifySelf: "center",
                      boxShadow:
                        "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;",
                    }}
                    alt="green iguana"
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        {/* Product details=====================> */}
        <Grid item md="5" sm="12">
          <Grid
            container
            // sm="12"
            gap="10px"
            flexDirection={"column"}
            sx={{
              boxShadow:
                "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;",
              padding: "20px",
              //   height: "fit-content ",
              fontWeight: "lighter",
            }}
          >
            <Typography variant="p">SKU:{data.sku}</Typography>
            <Typography variant="h6">
              <b>{data.name}</b>
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }} gap="20px">
              <Typography variant="p">
                <b>{data.price}$</b>
              </Typography>
            </Box>

            <Typography variant="p" sx={{ fontWeight: "100" }}>
              {data.description}
            </Typography>
            <Box>
              <Box display="flex">
                <Typography sx={{ fontWeight: "900", mb: "10px" }}>
                  Avaialable Colors
                </Typography>
              </Box>
              {/* =========================Color Data =================================> */}
              {SelectColor && (
                <Box display="flex" sx={{ marginBottom: "10px" }}>
                  <Typography>
                    <span style={{ fontWeight: "800" }}>Color</span> :{" "}
                    {SelectColor}
                  </Typography>
                </Box>
              )}
              <Box display="flex">
                {filterDataColorAndSize.length !== 0 &&
                  filterDataColorAndSize?.map((color) => (
                    <Box
                      sx={{
                        border: "1px solid Gray",
                        width: "content-fit",
                        padding: "10px",
                      }}
                    >
                      <Box
                        backgroundColor={color.color_code}
                        style={{
                          height: "20px",
                          width: "20px",
                          borderRadius: "50%",
                          border: "1px solid black",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setColor(color);
                        }}
                      ></Box>
                    </Box>
                  ))}
              </Box>
            </Box>
            <Box>
              <Box display="flex">
                <Typography sx={{ fontWeight: "900", mb: "10px" }}>
                  Available Sizes
                </Typography>
              </Box>
              {/* Sizes==============> */}
              {FilterSize.length !== 0 && (
                <Box display="flex">
                  {FilterSize.map((size) => {
                    console.log(size);
                    return (
                      <Box
                        sx={{
                          border: "1px solid Gray",
                          width: "content-fit",
                          padding: "10px",
                        }}
                      >
                        <Box
                          style={{
                            height: "20px",
                            width: "20px",
                            borderRadius: "50%",
                            textAlign: "center",
                          }}
                        >
                          {size.fittype_name}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
            <Box>
              <Typography
                variant="p"
                display={"flex"}
                alignItems="center"
                gap="10px"
              >
                <LocalShippingIcon /> Shipping will be calculated at the end{" "}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        {/* Buttons */}
        <Grid item xs="12">
          <Box display="flex" gap="20px" justifyContent={"center"}>
            <Button
              // variant="outlined"
              sx={{
                background: colors.darkRed,
                color: "white",
                border: "none",
                ":hover": { color: "black" },
              }}
              onClick={() => {
                handlePreviousButton();
              }}
            >
              prev
            </Button>

            <LoadingButton
              loading={Loading}
              sx={{
                background: colors.darkRed,
                color: "white",
                border: "none",
                ":hover": { color: "black" },
              }}
              // variant="outlined"
              onClick={() => {
                SubmitData();
              }}
            >
              Submit your data
            </LoadingButton>
          </Box>
        </Grid>
      </Grid>
    </>
    // <h1>sjdbj</h1>
  );
}

export default Step3ViewProduct;
